export default function COUNTBLANK() {
  return (
    <div className="p-4">
      <h1>COUNTBLANK</h1>
    </div>
  );
}
